export const PageText = {
  "_1": "Ontwikkelaars",
  "_2": "aircheckr kan eenvoudig worden geïntegreerd in je eigen toepassing. Ontdek hier meer technische informatie over het gebruik en de mogelijkheden van onze eenvoudige en krachtige API en widgets."
};

export const Categories = {
  "_1": {
    "title": "aircheckr token",
    "subcategories": [
      {
        "key": 0,
        "subtitle": "Je toegang tot aircheckr",
        "text": "Het enige dat je nodig hebt om aircheckr te gebruiken, is een persoonlijke aircheckr toegangstoken. Het is een tekenreeks waarmee je aircheckr kunt gebruiken in je eigen dienst of product. Je krijgt deze API sleutel automatisch wanneer je je aanmeldt voor aircheckr. Je kunt het vinden in je \"<a href=\"/dashboard\">persoonlijke accountpagina</a>\". Je kunt dezelfde token gebruiken voor al onze REST API's en widgets."
      }
    ]
  },
  "_2": {
    "title": "aircheckr API",
    "subcategories": [
      {
        "key": 0,
        "subtitle": "Documentatie",
        "text": "De aircheckr API documentatie geeft een uitgebreide uitleg over de API en het gebruik ervan.",
        "linkAddress": "/api_docs",
        "linkText": "Naar de Documentatie",
        "linkTarget": "_blank"
      },
      {
        "key": 1,
        "subtitle": "Integreer aircheckr in een handomdraai",
        "text": "Gebruik de API om de aircheckr gegevens op te halen die je nodig hebt voor je toepassing. De aircheckr API zorgt voor een soepele 'machine to machine' gegevensoverdracht en maakt het makkelijk om luchtkwaliteitsinfo te integreren in je eigen product."
      },
      {
        "key": 2,
        "subtitle": "De API maakt het mogelijk om te differentiëren volgens:",
        "text": "Locatie: gebaseerd op coördinaten of een administratieve naam (zoals stadsnaam)"
      },
      {
        "key": 3,
        "text": "Tijd: specifiek moment (bijvoorbeeld afgelopen uur of morgen), maar ook statistieken"
      },
      {
        "key": 4,
        "subtitle": "Welke luchtkwaliteitsinformatie kan ik ophalen?",
        "text": "Naast de aircheckr luchtkwaliteitsindex en aanbevelingen, kun je nog veel meer informatie uit aircheckr halen. Bekijk het <a href=\"https://aircheckr.com/help-and-guides/what-air-quality-info-can-i-get\">hier</a> of check de details in de <a href=\"api_docs/\" target=\"_blank\">API documentatie</a>."
      }
    ]
  },
  "_3": {
    "title": "aircheckr widgets",
    "subcategories": [
      {
        "key": 0,
        "subtitle": "Implementeer aircheckr in je eigen website",
        "text": "Je kunt de widget gemakkelijk in uw website integreren. Zie hier in het kort hoe:",
        "text_2": "Stap 1:<br/>Voeg een HTML5 <code>&lt;article&gt;</code> element in je website met klasse attribuut <code>ac-aircheckr-widget</code>, een <code>data-level</code>, een <code>data-type</code> en een <code>data-token</code> attribuut, zoals bijvoorbeeld: <br><code>&lt;article class=\"ac-aircheckr-widget\" data-level=\"city\" data-type=\"extended\" data-token=\"[je persoonlijke aircheckr token komt hier]\"&gt;&lt;/article&gt;</code>",
        "text_3": "Stap 2 (optioneel):<br/>Voeg extra gegevenskenmerken toe om je widget aan te passen: <code>data-theme</code>, <code>data-locale</code>, <code>data-default-location</code>",
        "text_4": "Stap 3:<br/>Laad het JavaScript bestand van de aircheckr widget door het plaatsen van een script tag achter je HTML5 <code>&lt;article&gt;</code> element:<br/><code>&lt;script src=\"https://widget.aircheckr.com/js/client.widget.js\"&gt;&lt;/script&gt;</code><br/><br/><a href=\"https://www.aircheckr.com/contact\">Contacteer ons</a> als je extra hulp nodig hebt."
      },
      {
        "key": 1,
        "subtitle": "Het is mogelijk om te differentiëren volgens:"
      },
      {
        "key": 2,
        "text": "Taal: Engels of Nederlands"
      },
      {
        "key": 3,
        "text": "Achtergrond: donker (aircheckr groen) of licht (wit)"
      }
    ]
  },
  "_4": {
    "subcategories": [
      {
        "key": 1,
        "subtitle": "Meer info",
        "text": "Als je nog vragen hebt, <a href=\"https://www.aircheckr.com/contact\">contacteer ons dan</a>."
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/nl/developers_page.js